<app-form-pyramid-item
  [prefilledName]="prefilledName"
  [prefilledCategoryId]="prefilledCategoryId"
  [prefilledSubCategoryId]="prefilledSubCategoryId"
  [lockNameAndCategories]="false"
  (formValidityChanged)="onFormValidityChanged($event)">
</app-form-pyramid-item>
